import React from 'react';
import { View, StyleSheet, Linking, TouchableOpacity } from 'react-native';
import { Text, Divider } from 'react-native-paper';
import { AVAQualisTheme } from '../theme/theme';

export default function FooterComponent() {
  const openEmail = (email) => {
    Linking.openURL(`mailto:${email}`);
  };

  const openWhatsApp = (phone, message = '') => {
    const cleanPhone = phone.replace(/\D/g, '');
    const encodedMessage = encodeURIComponent(message);
    Linking.openURL(`https://wa.me/${cleanPhone}${message ? `?text=${encodedMessage}` : ''}`);
  };

  const openPhone = (phone) => {
    Linking.openURL(`tel:${phone.replace(/\D/g, '')}`);
  };

  const openMaps = () => {
    Linking.openURL('https://maps.app.goo.gl/EYYmrS2ZRCSsbvLc7');
  };

  const openManual = () => {
    Linking.openURL('https://www.gov.br/ebserh/pt-br/hospitais-universitarios/regiao-sudeste/hc-ufu/governanca/gestao-da-qualidade/manual-selo-ebserh-de-qualidade');
  };

  const openSelo = () => {
    Linking.openURL('https://www.gov.br/ebserh/pt-br/acesso-a-informacao/acoes-e-programas/programas-projetos-acoes-obras-e-atividades/programa-e-selo-ebserh-de-qualidade');
  };

  const openEbserhSite = () => {
    Linking.openURL('https://www.gov.br/ebserh/pt-br/');
  };

  const openHcUfuSite = () => {
    Linking.openURL('https://www.gov.br/ebserh/pt-br/hospitais-universitarios/regiao-sudeste/hc-ufu');
  };

  return (
    <View style={styles.footer} role="contentinfo">
      {/* ✅ CONTEÚDO SEO ADICIONAL NO FOOTER */}
      <View style={styles.seoContent}>
        <Text style={styles.seoH3}>AVAQualis.com - Protótipo de Ferramenta Mobile para Programa AVAQualis</Text>
        <Text style={styles.seoText}>
        AVAQualis.com é um protótipo de ferramenta mobile em desenvolvimento pelas unidades UGITS (Unidade de Gestão da Inovação Tecnológica em Saúde)
e UGQ (Unidade de Gestão da Qualidade) do Hospital de Clínicas da Universidade Federal de Uberlândia (HC-UFU/EBSERH).
Este protótipo visa auxiliar na avaliação do programa AVAQualis, que é o programa oficial de acreditação hospitalar da Rede EBSERH,
aplicado anualmente a todos os hospitais universitários federais vinculados à rede.
O AVAQualis.com está atualmente em fase de testes e desenvolvimento.     </Text>
        <Text style={styles.seoKeywords}>
          Palavras-chave: AVAQualis.com, protótipo ferramenta mobile, programa AVAQualis, EBSERH, acreditação hospitalar, 
          HC-UFU/EBSERH, hospitais universitários federais, selo EBSERH qualidade, sistema avaliação hospitalar, 
          conformidade hospitalar, gestão qualidade, avaliação interna, UGITS, UGQ, Uberlândia, Minas Gerais, 
          desenvolvimento ferramenta, teste prático, fase desenvolvimento
        </Text>
      </View>

      {/* ✅ SEÇÃO DO MANUAL COM MAIS KEYWORDS */}
      <TouchableOpacity style={styles.manualSection} onPress={openManual}>
        <Text style={styles.manualIcon}>📖</Text>
        <View style={styles.manualContent}>
          <Text style={styles.manualTitle}>MANUAL DO PROGRAMA AVAQualis EBSERH</Text>
          <Text style={styles.manualSubtitle}>
            Programa oficial de acreditação da rede EBSERH aplicado anualmente aos hospitais universitários federais
          </Text>
          <Text style={styles.manualVersion}>Versão: 03 | 2022 | Programa AVAQualis - Selo EBSERH de Qualidade</Text>
          <Text style={styles.manualAction}>📎 Clique para acessar o manual oficial do programa AVAQualis</Text>
        </View>
      </TouchableOpacity>

      <View style={styles.brandSection}>
        <Text style={styles.brandText}>
          <Text style={styles.titleDecorationLeft}>✧</Text>
          <Text style={styles.brandHighlight}>AVAQ</Text>
          <Text style={styles.brandSecondary}>ualis.com</Text>
          <Text style={styles.titleDecorationRight}>✧</Text>
        </Text>

        <Text style={styles.tagline}>
          Protótipo de Ferramenta Mobile para auxiliar na avaliação do programa AVAQualis no HC-UFU/EBSERH
        </Text>
      </View>

      <Text style={styles.partnershipInfo}>
        Protótipo desenvolvido por:  
        <Text style={styles.partnershipHighlight}> 🚀 UGITS</Text>
        {' (Unidade de Gestão da Inovação Tecnológica em Saúde) + '}
        <Text style={styles.partnershipHighlight}>📋 UGQ</Text>
        {' (Unidade de Gestão da Qualidade) do HC-UFU/EBSERH'}
      </Text>

      <Divider style={styles.divider} />

      {/* ✅ LINKS IMPORTANTES PARA SEO */}
      <View style={styles.importantLinksSection}>
        <Text style={styles.linksTitle}>🔗 Links Importantes:</Text>
        <View style={styles.linksGrid}>
          <TouchableOpacity style={styles.linkItem} onPress={openEbserhSite}>
            <Text style={styles.linkIcon}>🏛️</Text>
            <Text style={styles.linkText}>Portal EBSERH</Text>
          </TouchableOpacity>

          <TouchableOpacity style={styles.linkItem} onPress={openHcUfuSite}>
            <Text style={styles.linkIcon}>🏥</Text>
            <Text style={styles.linkText}>Portal HC-UFU/EBSERH</Text>
          </TouchableOpacity>

          <TouchableOpacity style={styles.linkItem} onPress={openManual}>
            <Text style={styles.linkIcon}>📋</Text>
            <Text style={styles.linkText}>Manual AVAQualis</Text>
          </TouchableOpacity>

          <TouchableOpacity style={styles.linkItem} onPress={openSelo}>
            <Text style={styles.linkIcon}>⭐</Text>
            <Text style={styles.linkText}>Programa Selo EBSERH de Qualidade</Text>
          </TouchableOpacity>
        </View>
      </View>

      <Divider style={styles.divider} />

      <View style={styles.infoGrid}>
        <TouchableOpacity style={styles.infoItem} onPress={openMaps}>
          <Text style={styles.infoIcon}>📍</Text>
          <View style={styles.infoContent}>
            <Text style={styles.infoTitle}>Endereço UGITS HC-UFU/EBSERH</Text>
            <Text style={styles.infoText}>R. República do Piratini, 1418 - Bloco 8F</Text>
            <Text style={styles.infoSubtext}>Umuarama, Uberlândia - MG, CEP: 38405-320</Text>
          </View>
        </TouchableOpacity>

        <View style={styles.infoItem}>
          <Text style={styles.infoIcon}>🕒</Text>
          <View style={styles.infoContent}>
            <Text style={styles.infoTitle}>Horário Atendimento</Text>
            <Text style={styles.infoText}>Segunda a sexta-feira</Text>
            <Text style={styles.infoSubtext}>8h às 16h (horário de Brasília)</Text>
          </View>
        </View>

        <TouchableOpacity style={styles.infoItem} onPress={() => openEmail('ugits.hc-ufu@ebserh.gov.br')}>
          <Text style={styles.infoIcon}>📧🚀</Text>
          <View style={styles.infoContent}>
            <Text style={styles.infoTitle}>Email UGITS</Text>
            <Text style={styles.infoText}>ugits.hc-ufu@ebserh.gov.br</Text>
            <Text style={styles.infoSubtext}>Suporte técnico AVAQualis.com</Text>
          </View>
        </TouchableOpacity>

        <TouchableOpacity style={styles.infoItem} onPress={() => openWhatsApp('553432182323', 'Olá, gostaria de falar com a UGITS para tirar dúvidas sobre o AVAQualis.com.')}>
          <Text style={styles.infoIcon}>📱🚀</Text>
          <View style={styles.infoContent}>
            <Text style={styles.infoTitle}>WhatsApp UGITS/UGPESQ</Text>
            <Text style={styles.infoText}>(34) 3218-2323</Text>
            <Text style={styles.infoSubtext}>Suporte desenvolvimento</Text>
          </View>
        </TouchableOpacity>

        <TouchableOpacity style={styles.infoItem} onPress={() => openEmail('uquali.hc-ufu@ebserh.gov.br')}>
          <Text style={styles.infoIcon}>📧📋</Text>
          <View style={styles.infoContent}>
            <Text style={styles.infoTitle}>Email UGQ</Text>
            <Text style={styles.infoText}>uquali.hc-ufu@ebserh.gov.br</Text>
            <Text style={styles.infoSubtext}>Dúvidas de usabilidade</Text>
          </View>
        </TouchableOpacity>

        <TouchableOpacity style={styles.infoItem} onPress={() => openPhone('553432182858')}>

          <Text style={styles.infoIcon}>☎️📋</Text>
          <View style={styles.infoContent}>
            <Text style={styles.infoTitle}>Telefone UGQ</Text>
            <Text style={styles.infoText}>(34) 3218-2858</Text>
            <Text style={styles.infoSubtext}>Dúvidas de usabilidade</Text>
          </View>
        </TouchableOpacity>
      </View>

      <Divider style={styles.divider} />

      {/* ✅ INFORMAÇÕES ADICIONAIS PARA SEO */}
      <View style={styles.additionalInfo}>
        <Text style={styles.additionalTitle}>🎯 Sobre o AVAQualis.com:</Text>
        <Text style={styles.additionalText}>
          • Protótipo de ferramenta mobile em fase de desenvolvimento e testes{'\n'}
          • Desenvovimento feito em parceria pelas unidades 🚀 UGITS + 📋 UGQ do HC-UFU/EBSERH{'\n'}
          • Visa otimizar a avaliação do programa AVAQualis no HC-UFU/EBSERH{'\n'}
          • Não é um sistema oficial, mas sim um protótipo experimental visando a melhoria do processo{'\n'}
          • Caminhando para se tornar ferramenta relevante e significativa no processo de acreditação
        </Text>
      </View>

      <Divider style={styles.divider} />

      <Text style={styles.copyright}>
        © 2025 HC-UFU/EBSERH. Todos os direitos reservados.
        {'\n'}Protótipo AVAQualis.com desenvolvido pela '
        <Text style={styles.copyrightHighlight}>UGITS</Text>
        {' (Unidade de Gestão da Inovação Tecnológica em Saúde) + '}
        <Text style={styles.copyrightHighlight}>UGQ</Text>
        {' (Unidade de Gestão da Qualidade) do Hospital de Clínicas da Universidade Federal de Uberlândia.'}
        {'\n\n'}
        <Text style={styles.copyrightSmall}>
          Protótipo de ferramenta mobile em desenvolvimento para auxiliar na avaliação do programa AVAQualis no HC-UFU/EBSERH. 
          O programa AVAQualis é o programa oficial de acreditação da rede EBSERH, conforme Manual de Requisitos 
          do Programa e Selo Ebserh de Qualidade - Versão 03/2022. Este site não representa um sistema oficial.
        </Text>
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  footer: {
    backgroundColor: '#F0F1F2',
    borderTopWidth: 2,
    borderTopColor: AVAQualisTheme.colors.primary,
    paddingVertical: 16,
    paddingHorizontal: 16,
    ...AVAQualisTheme.shadows.small,
  },
  // ✅ ESTILOS PARA CONTEÚDO SEO (INVISÍVEL MAS INDEXÁVEL)
  seoContent: {
    position: 'absolute',
    left: -9999,
    top: -9999,
    width: 1,
    height: 1,
    overflow: 'hidden',
  },
  seoH3: {
    fontSize: 18,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
  },
  seoText: {
    fontSize: 14,
    color: AVAQualisTheme.colors.tertiary,
    lineHeight: 20,
  },
  seoKeywords: {
    fontSize: 12,
    color: AVAQualisTheme.colors.secondary,
    lineHeight: 16,
  },
  brandSection: {
    alignItems: 'center',
    marginBottom: 8,
  },
  brandText: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  brandHighlight: {
    color: AVAQualisTheme.colors.primary,
    textShadowColor: `${AVAQualisTheme.colors.primary}30`,
    textShadowOffset: { width: 0, height: 1 },
    textShadowRadius: 1,
  },
  brandSecondary: {
    color: AVAQualisTheme.colors.secondary,
    textShadowColor: `${AVAQualisTheme.colors.secondary}30`,
    textShadowOffset: { width: 0, height: 1 },
    textShadowRadius: 1,
  },
  titleDecorationLeft: {
    fontSize: 18,
    color: AVAQualisTheme.colors.primary,
    marginRight: 6,
    opacity: 0.9,
  },
  titleDecorationRight: {
    fontSize: 18,
    color: AVAQualisTheme.colors.secondary,
    marginLeft: 6,
    opacity: 0.9,
  },
  tagline: {
    fontSize: 11,
    color: AVAQualisTheme.colors.secondary,
    textAlign: 'center',
    marginTop: 2,
    fontWeight: '500',
  },
  partnershipInfo: {
    fontSize: 11,
    color: AVAQualisTheme.colors.secondary,
    textAlign: 'center',
    marginBottom: 8,
    fontWeight: '500',
    lineHeight: 16,
  },
  partnershipHighlight: {
    color: AVAQualisTheme.colors.primary,
    fontWeight: 'bold',
  },
  // ✅ ESTILOS DA SEÇÃO DO MANUAL (OTIMIZADO)
  manualSection: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderRadius: AVAQualisTheme.borderRadius.lg,
    padding: 12,
    marginVertical: 8,
    borderWidth: 2,
    borderColor: AVAQualisTheme.colors.primary,
    borderStyle: 'dashed',
    ...AVAQualisTheme.shadows.medium,
  },
  manualIcon: {
    fontSize: 20,
    marginRight: 12,
    marginTop: 2,
  },
  manualContent: {
    flex: 1,
  },
  manualTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
    marginBottom: 3,
    lineHeight: 16,
  },
  manualSubtitle: {
    fontSize: 10,
    color: AVAQualisTheme.colors.secondary,
    marginBottom: 2,
    lineHeight: 14,
    fontWeight: '600',
  },
  manualVersion: {
    fontSize: 9,
    color: AVAQualisTheme.colors.tertiary,
    marginBottom: 4,
    fontWeight: '500',
  },
  manualAction: {
    fontSize: 9,
    color: AVAQualisTheme.colors.info,
    fontStyle: 'italic',
    fontWeight: '500',
  },
  // ✅ NOVA SEÇÃO DE LINKS IMPORTANTES
  importantLinksSection: {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: AVAQualisTheme.borderRadius.md,
    padding: 10,
    marginVertical: 6,
    borderWidth: 1,
    borderColor: `${AVAQualisTheme.colors.primary}30`,
    ...AVAQualisTheme.shadows.small,
  },
  linksTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
    marginBottom: 6,
    textAlign: 'center',
  },
  linksGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  linkItem: {
    width: '48%',
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 4,
    paddingHorizontal: 6,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    borderRadius: AVAQualisTheme.borderRadius.sm,
    marginBottom: 4,
  },
  linkIcon: {
    fontSize: 12,
    marginRight: 6,
  },
  linkText: {
    fontSize: 9,
    color: AVAQualisTheme.colors.secondary,
    fontWeight: '600',
  },
  // ✅ NOVA SEÇÃO DE INFORMAÇÕES ADICIONAIS
  additionalInfo: {
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderRadius: AVAQualisTheme.borderRadius.md,
    padding: 10,
    marginVertical: 6,
    borderWidth: 1,
    borderColor: `${AVAQualisTheme.colors.secondary}30`,
    ...AVAQualisTheme.shadows.small,
  },
  additionalTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.secondary,
    marginBottom: 6,
    textAlign: 'center',
  },
  additionalText: {
    fontSize: 9,
    color: AVAQualisTheme.colors.tertiary,
    lineHeight: 13,
    textAlign: 'left',
  },
  divider: {
    marginVertical: 8,
    backgroundColor: AVAQualisTheme.colors.primary,
    opacity: 0.3,
    height: 1.5,
  },
  infoGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  infoItem: {
    width: '48%',
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 6,
    paddingVertical: 6,
    paddingHorizontal: 8,
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderWidth: 1,
    borderColor: `${AVAQualisTheme.colors.primary}20`,
    ...AVAQualisTheme.shadows.small,
  },
  infoIcon: {
    fontSize: 14,
    marginRight: 8,
    marginTop: 1,
  },
  infoContent: {
    flex: 1,
  },
  infoTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
    marginBottom: 2,
  },
  infoText: {
    fontSize: 10,
    color: AVAQualisTheme.colors.secondary,
    lineHeight: 13,
    fontWeight: '500',
  },
  infoSubtext: {
    fontSize: 9,
    color: AVAQualisTheme.colors.tertiary,
    lineHeight: 11,
  },
  copyright: {
    fontSize: 9,
    color: AVAQualisTheme.colors.secondary,
    textAlign: 'center',
    lineHeight: 13,
    fontWeight: '500',
    opacity: 0.9,
  },
  copyrightHighlight: {
    color: AVAQualisTheme.colors.primary,
    fontWeight: 'bold',
  },
  copyrightSmall: {
    fontSize: 8,
    color: AVAQualisTheme.colors.tertiary,
    lineHeight: 12,
    fontStyle: 'italic',
  },
});